export default __webpack_public_path__ + "static/media/solfeggioar.baa70d87.jpeg";